// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"19c6bd4f","216":"490edaee","401":"26671f92","734":"9776697f","768":"7d706449"}[chunkId] + ".chunk.js";
};